import { render, staticRenderFns } from "./SlickCollapseItem.vue?vue&type=template&id=6aaee86a&scoped=true"
import script from "./SlickCollapseItem.vue?vue&type=script&lang=js"
export * from "./SlickCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./SlickCollapseItem.vue?vue&type=style&index=0&id=6aaee86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaee86a",
  null
  
)

export default component.exports